import {
	GetPlaceWizardBasicInformationStepResponse,
} from "#resources/api/enterprise-generated";
import { createQueryFactory } from "../query-factory";

export const { useApiHook: useGetPlaceWizardStatus } = createQueryFactory(
	"getPlaceWizardStatus",
	{
		retry: false,
		refetchOnWindowFocus: false,
		refetchOnMount: false,
		refetchOnReconnect: false,
	},
);

export const { useApiHook: useGetPlaceWizardBasicInformationStep } = createQueryFactory(
	"getPlaceWizardBasicInformationStep",
	{
		retry: false,
		refetchOnWindowFocus: false,
		refetchOnMount: false,
		refetchOnReconnect: false,
	},
);

export const useGetPlaceWizardConfiguration = (
	params: { placeId: string },
	options?: { enabled?: boolean },
) => {
	return useGetPlaceWizardBasicInformationStep(params, {
		enabled: options?.enabled !== false && Boolean(params.placeId),
	});
};

export type {
	GetPlaceWizardBasicInformationStepResponse,
};